import React, { createContext, useContext } from 'react';
import { useSidebarState as useSidebarStateInternal } from './useSidebarState';

const SidebarStateContext = createContext(null);

export function SidebarStateProvider({ children }) {
  const state = useSidebarStateInternal();
  return (
    <SidebarStateContext.Provider value={state}>
      {children}
    </SidebarStateContext.Provider>
  );
}

const FALLBACK = {
  locked: false,
  expanded: false,
  hovered: false,
  toggleLock: () => {},
  onMouseEnter: () => {},
  onMouseLeave: () => {},
  collapseHover: () => {},
  forceCollapsed: false,
  setPeek: () => {},
};

export function useSidebarStateContext() {
  return useContext(SidebarStateContext) || FALLBACK;
}

export default SidebarStateContext;
